module.exports = window.initializeRemote('looker_workspaces');